/*=========================================================================================
  File Name: module-licenseinfo-actions.js
  Description: LicenseInfo Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import LicenseInfoAPI from '@/api/LicenseInfoAPI.js';
import OrderAPI from '@/api/OrderAPI.js';

export default {
	// Lấy danh sách order
	getPaggingOrder: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OrderAPI.getAPIUrl() + '/paging',
				data: payload
			},
			true
		);

		if (res && res.Success && res.Data) {
			context.commit('updatePaggingOrder', res);
		}

		return res;
	},

	// Lấy thông tin detail của order
	getOrderDetail: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: OrderAPI.getAPIUrl() + '/getOrderDetailByMisaOrderId',
			params: payload
		});

		return res.Data;
	},

	// Lấy thông tin license
	getInfoByTaxCode: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: LicenseInfoAPI.getAPIUrl() + '/info',
			params: payload
		});

		if (res && res.Success && res.Data) {
			context.commit('updateLicenseInfo', res.Data);
			return res.Data;
		}

		return null;
	},

	// Lấy dữ liệu an toàn để khởi tạo PLF.
    getTokenMisaALNUser: async function (context, payload) {
        let res = await httpClient.getAsync({
            url: LicenseInfoAPI.getAPIUrl() + `/token-misa-aln-user/${payload}`
        });

		if (res && res.Success && res.Data) {
			return res.Data;
		}

		return null;
	},

	checkLicenseInfo: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: LicenseInfoAPI.getAPIUrl() + `/info/${payload.TaxCode}`,
			data: payload
		});
		return res;
	},

	updateViewWarning: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: LicenseInfoAPI.getAPIUrl() + '/updateviewwarning',
			data: payload
		});
		return res;
	}
};
